<template>
    <div id="parts">
        <v-alert dense border="bottom" type="primary" icon="mdi-information"
            >PARTS INFORMATION
            <div style="float: right">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            class="mb-1"
                            x-small
                            @click="
                                showpart(detailcase.maincase_id),
                                    (dialogpart = true)
                            "
                            color="grey lighten-5"
                            fab
                            v-on="on"
                            target="_blank"
                        >
                            <v-icon color="primary">mdi-magnify</v-icon>
                        </v-btn>
                    </template>
                    <span> More Part Detail</span>
                </v-tooltip>
            </div>
        </v-alert>
        <!-- <v-alert> -->
        <!-- <v-card-text> -->

        <v-row>
            <v-col cols="12" class="mar-t-10" v-if="detailcase.offer_part_no">
                <div class="ml-5">
                    <span class="font-b blue--text">
                        Offier Part No :
                    </span>
                    <span class="font-b">
                        {{ detailcase.offer_part_no }}
                    </span>
                    <br />
                    <span class="font-b blue--text">
                        Offier Part Desc :
                    </span>
                    <span>
                        {{ detailcase.offer_part_desc }}
                    </span>
                </div>
            </v-col>
            <v-col cols="12" class="mar-t-15">
                <!-- <v-data-table
                            :headers="headers"
                            :items="this.detailcase.parts"
                            :items-per-page="10"
                            :loading="isLoading"
                            :search="search"
                            loading-text="Loading... Please wait"
                        >
                        </v-data-table> -->
                <v-simple-table class="table-inv mb-3">
                    <template v-slot:default>
                        <thead>
                            <tr class="col-tr-1">
                                <th class="text-center">#</th>
                                <th
                                    class="text-center"
                                    v-if="detailcase.project_name == 'CDAX'"
                                >
                                    Line no.
                                </th>
                                <th class="text-center">
                                    PO / Sub<br />Part_Status_Name
                                </th>
                                <th class="text-center">Part</th>
                                <th class="text-center">RMA</th>
                                <th class="text-center">Ship Date</th>
                                <th class="text-center">CE Status</th>
                                <th class="text-center">CT Old</th>
                                <th class="text-center">CT New</th>
                                <th class="text-center">Uefi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(row, index) in detailcase.parts"
                                :key="index"
                            >
                                <td class="text-center">{{ index + 1 }}.</td>
                                <td
                                    class="text-center"
                                    v-if="detailcase.project_name == 'CDAX'"
                                >
                                    {{ row.ponumber_line }}
                                </td>

                                <td class="text-center">
                                    <v-badge
                                        inline
                                        color="blue lighten-2"
                                        :content="row.subcase"
                                    >
                                        <strong>{{ row.ponumber }}</strong>
                                    </v-badge>
                                    <!-- <br />
                                    <span v-if="row.part_status_name != null">{{
                                        row.part_status_name
                                    }}</span> -->
                                </td>
                                <td>
                                    <strong>{{ row.part_name }}</strong>
                                    <v-chip
                                        v-if="row.status == 'Back Order'"
                                        x-small
                                        class="ml-2"
                                        color="red"
                                        style="color: white"
                                        >{{ row.status }}</v-chip
                                    >
                                    <v-chip
                                        v-else
                                        x-small
                                        class="ml-2"
                                        color="green lighten-3"
                                        style="color: white"
                                        >{{ row.status }}</v-chip
                                    >
                                    <!-- v-if="row.status === 'Back Order' && row.eta" -->
                                    <v-chip
                                        v-if="row.eta"
                                        x-small
                                        class="ml-2"
                                        color="blue lighten-2"
                                        >{{ row.eta }}</v-chip
                                    >
                                    <br />
                                    <div
                                        class="font-weight-light"
                                        v-if="row.part_description"
                                    >
                                        <span
                                            v-if="
                                                row.part_description.length < 30
                                            "
                                        >
                                            {{ row.part_description }}
                                        </span>
                                        <span v-else>
                                            <v-tooltip bottom>
                                                <template
                                                    v-slot:activator="{ on }"
                                                >
                                                    <span v-on="on">
                                                        {{
                                                            row.part_description.substring(
                                                                0,
                                                                30
                                                            ) + "..."
                                                        }}
                                                    </span>
                                                </template>
                                                <span>
                                                    {{ row.part_description }}
                                                </span>
                                            </v-tooltip>
                                        </span>
                                    </div>

                                    <hr
                                        v-if="
                                            row.UsageQuantity != null ||
                                                row.OriginalPartNumber !=
                                                    null ||
                                                row.IGSOOrderNumber != null
                                        "
                                    />

                                    <span
                                        class="blue--text"
                                        v-if="row.OriginalPartNumber"
                                    >
                                        {{
                                            "Original :" +
                                                row.OriginalPartNumber
                                        }}
                                    </span>
                                    <v-chip
                                        x-small
                                        class="mr-1 white--text"
                                        color="grey"
                                        v-if="row.UsageQuantity"
                                    >
                                        {{ row.UsageQuantity }}
                                    </v-chip>
                                    <br v-if="row.IGSOOrderNumber" />
                                    <span
                                        class="blue--text"
                                        v-if="row.IGSOOrderNumber"
                                    >
                                        {{ "IGSO : " + row.IGSOOrderNumber }}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="row.rma">{{ row.rma }}</span>
                                    <span v-if="row.singlepart">{{
                                        row.singlepart
                                    }}</span>
                                </td>
                                <td class="text-center">
                                    {{ row.ship_date_x }}
                                </td>
                                <td>{{ row.ce_status }}</td>
                                <td>
                                    {{ row.ct_old }}
                                    <v-tooltip color="black" bottom lazy>
                                        <template #activator="{ on }">
                                            <v-chip
                                                v-on="on"
                                                v-if="
                                                    row.ct_old != '' &&
                                                        row.ct_old !== null
                                                "
                                                @click="doCopy(row.ct_old)"
                                                small
                                                class="success"
                                            >
                                                <v-icon small color="white"
                                                    >mdi-clipboard-file-outline</v-icon
                                                >
                                            </v-chip>
                                        </template>
                                        <span>Copy</span>
                                    </v-tooltip>
                                </td>
                                <td>
                                    {{ row.ct_new }}
                                    <v-tooltip color="black" bottom lazy>
                                        <template #activator="{ on }">
                                            <v-chip
                                                v-on="on"
                                                v-if="
                                                    row.ct_new != '' &&
                                                        row.ct_new !== null
                                                "
                                                @click="doCopy(row.ct_new)"
                                                small
                                                class="success"
                                            >
                                                <v-icon small color="white"
                                                    >mdi-clipboard-file-outline</v-icon
                                                >
                                            </v-chip>
                                        </template>
                                        <span>Copy</span>
                                    </v-tooltip>
                                </td>
                                <td>
                                    {{ row.uefi }}
                                    <v-tooltip color="black" bottom lazy>
                                        <template #activator="{ on }">
                                            <v-chip
                                                v-on="on"
                                                v-if="
                                                    row.uefi != '' &&
                                                        row.uefi !== null
                                                "
                                                @click="doCopy(row.uefi)"
                                                small
                                                class="success"
                                            >
                                                <v-icon small color="white"
                                                    >mdi-clipboard-file-outline</v-icon
                                                >
                                            </v-chip>
                                        </template>
                                        <span>Copy</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                            <br />
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-dialog
                v-model="dialogpart"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary" data-v-f3f3eg9>
                        <v-btn icon dark @click="dialogpart = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>PARTS INFORMATION</v-toolbar-title>
                        <v-spacer> </v-spacer>
                    </v-toolbar>

                    <v-container fluid>
                        <div v-for="(datapart1, i) in datapart" :key="i">
                            <v-row dense>
                                <v-col cols="12">
                                    <v-card>
                                        <v-card-actions>
                                            <v-row>
                                                <v-col cols="12" sm="4"
                                                    ><b>PO Number : </b
                                                    >{{ datapart1.ponumber }}
                                                </v-col>

                                                <v-col cols="12" sm="8"
                                                    ><b>Part Name : </b>
                                                    <b
                                                        >{{
                                                            datapart1.recommend_part_name
                                                        }}
                                                    </b>
                                                    |
                                                    {{
                                                        datapart1.recommend_part_desc
                                                    }}
                                                </v-col>

                                                <v-col cols="12" sm="4"
                                                    ><b>Ship Date : </b>
                                                    {{ datapart1.ship_date_x }}
                                                </v-col>

                                                <v-col cols="12" sm="4"
                                                    ><b>ETA : </b>
                                                    {{ datapart1.eta }}
                                                </v-col>

                                                <v-col cols="12" sm="4">
                                                    <span v-if="datapart1.rma">
                                                        <b>RMA : </b
                                                        >{{ datapart1.rma }}
                                                    </span>
                                                    <span
                                                        v-if="
                                                            datapart1.singlepart
                                                        "
                                                    >
                                                        <b>Singlepart : </b
                                                        >{{
                                                            datapart1.singlepart
                                                        }}
                                                    </span>
                                                </v-col>

                                                <v-col cols="12" sm="4"
                                                    ><b>Onhand Date : </b
                                                    >{{
                                                        datapart1.onhand_date_x
                                                    }}
                                                </v-col>

                                                <v-col cols="12" sm="8"
                                                    ><b>Onhand By : </b
                                                    >{{ datapart1.onhand_by_x }}
                                                </v-col>

                                                <v-col cols="12" sm="4"
                                                    ><b>Engineer Status : </b>
                                                    {{ datapart1.ce_status }}
                                                </v-col>

                                                <v-col cols="12" sm="4"
                                                    ><b>CT Old : </b>
                                                    {{ datapart1.ct_old }}
                                                </v-col>
                                                <v-col cols="12" sm="4"
                                                    ><b>CT New : </b>
                                                    {{ datapart1.ct_new }}
                                                </v-col>
                                                <v-col cols="12"
                                                    ><b>UEFI : </b>
                                                    {{ datapart1.ct_new }}
                                                </v-col>

                                                <v-col cols="12" sm="4"
                                                    ><b>Return Date : </b>
                                                    {{
                                                        datapart1.ce_return_date_x
                                                    }}
                                                </v-col>

                                                <v-col cols="12" sm="4"
                                                    ><b>Return By : </b>
                                                    {{
                                                        datapart1.ce_return_by_x
                                                    }}
                                                </v-col>

                                                <v-col cols="12" sm="4"
                                                    ><b>Return No : </b>
                                                    {{ datapart1.return_no }}
                                                </v-col>
                                            </v-row>
                                        </v-card-actions>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </div>
                    </v-container>

                    <!-- <v-list
                            style="border:2px solid black;"
                            three-line
                            subheader
                            v-for="(datapart1, i) in datapart"
                            :key="i"
                        >
                            <v-row>
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label style="font-weight:bold;"
                                                    >Eta :
                                                </label>
                                                {{ datapart1.eta }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label style="font-weight:bold;"
                                                    >Ct_Old :
                                                </label>
                                                {{ datapart1.ct_old }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label style="font-weight:bold;"
                                                    >Ct_New :
                                                </label>
                                                {{ datapart1.ct_new }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                            <v-row style="margin-top:-70px">
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label style="font-weight:bold;"
                                                    >Recommend_Desc:</label
                                                >
                                                {{
                                                    datapart1.recommend_part_desc
                                                }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label style="font-weight:bold;"
                                                    >Recommend_By/Date:</label
                                                >
                                                {{ datapart1.recommend_by_x }}
                                                {{ datapart1.recommend_date_x }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                            <v-row style="margin-top:-50px">
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label style="font-weight:bold;"
                                                    >Singlepart :</label
                                                >
                                                {{
                                                    datapart1.singlepart
                                                }} </v-list-item-title
                                            ><v-list-item-content>
                                            </v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label style="font-weight:bold;"
                                                    >RMA :</label
                                                >
                                                {{
                                                    datapart1.rma
                                                }}</v-list-item-title
                                            ><v-list-item-content>
                                            </v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label style="font-weight:bold;"
                                                    >PoNumber :</label
                                                >
                                                {{
                                                    datapart1.ponumber
                                                }} </v-list-item-title
                                            ><v-list-item-content>
                                            </v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                            <v-row style="margin-top:-50px">
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label style="font-weight:bold;"
                                                    >Issue_Desc :</label
                                                >
                                                {{
                                                    datapart1.issue_part_desc
                                                }} </v-list-item-title
                                            ><v-list-item-content>
                                            </v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label style="font-weight:bold;"
                                                    >Issue_Serial :</label
                                                >
                                                {{
                                                    datapart1.issue_sn
                                                }}</v-list-item-title
                                            ><v-list-item-content>
                                            </v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label style="font-weight:bold;"
                                                    >Issue_By/Date :</label
                                                >
                                                {{ datapart1.issue_by_x }}<br />
                                                <label
                                                    style="margin-left:110px;"
                                                    >{{
                                                        datapart1.issue_date_x
                                                    }}
                                                </label> </v-list-item-title
                                            ><v-list-item-content>
                                            </v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                            <v-row style="margin-top:-70px">
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label style="font-weight:bold;"
                                                    >Ship_Date :</label
                                                >
                                                {{
                                                    datapart1.ship_date_x
                                                }} </v-list-item-title
                                            ><v-list-item-content>
                                            </v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label style="font-weight:bold;"
                                                    >Is_Backorder :</label
                                                >
                                                {{
                                                    datapart1.is_backorder
                                                }}</v-list-item-title
                                            ><v-list-item-content>
                                            </v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label style="font-weight:bold;"
                                                    >Onhand_By/Date :</label
                                                >
                                                {{ datapart1.onhand_by_x
                                                }}<br />
                                                <label
                                                    style="margin-left:110px;"
                                                    >{{
                                                        datapart1.onhand_date_x
                                                    }}
                                                </label> </v-list-item-title
                                            ><v-list-item-content>
                                            </v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                            <v-row style="margin-top:-70px">
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label style="font-weight:bold;"
                                                    >Ce_Status :</label
                                                >
                                                {{
                                                    datapart1.ce_status
                                                }} </v-list-item-title
                                            ><v-list-item-content>
                                            </v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label style="font-weight:bold;"
                                                    >Ce_ReturnBy/Date :</label
                                                >
                                                {{ datapart1.ce_return_by_x
                                                }}<br />
                                                <label
                                                    style="margin-left:140px;"
                                                    >{{
                                                        datapart1.ce_return_date_x
                                                    }}
                                                </label></v-list-item-title
                                            ><v-list-item-content>
                                            </v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label
                                                    style="font-weight:bold;"
                                                ></label> </v-list-item-title
                                            ><v-list-item-content>
                                            </v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                            <v-row style="margin-top:-70px">
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label style="font-weight:bold;"
                                                    >Return_No :</label
                                                >
                                                {{
                                                    datapart1.return_no
                                                }} </v-list-item-title
                                            ><v-list-item-content>
                                            </v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label style="font-weight:bold;"
                                                    >Receive_Sn :</label
                                                >
                                                {{
                                                    datapart1.receive_sn
                                                }} </v-list-item-title
                                            ><v-list-item-content>
                                            </v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="4">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <label
                                                    style="font-weight:bold;"
                                                ></label> </v-list-item-title
                                            ><v-list-item-content>
                                            </v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                        </v-list> -->
                    <v-divider></v-divider>
                </v-card>
            </v-dialog>
        </v-row>
        <v-dialog v-model="dialog" width="800px">
            <v-card>
                <v-card-title>
                    <span class="headline">Part Detail</span>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col md="2">
                            <span class="font-weight-bold">Part No :</span>
                        </v-col>
                        <v-col md="2">
                            <span class="font-weight-bold">part_name</span>
                        </v-col>
                        <v-col md="2">
                            <span class="font-weight-bold"
                                >Part Description :</span
                            >
                        </v-col>
                        <v-col md="2">
                            <span class="font-weight-bold">{{
                                part_description
                            }}</span>
                        </v-col>
                        <v-divider></v-divider>
                        <v-col md="2">
                            <span class="font-weight-bold">Part status :</span>
                        </v-col>
                        <v-col md="2">
                            <span class="font-weight-bold">{{ status }}</span>
                        </v-col>
                        <v-col md="2">
                            <span class="font-weight-bold"
                                >Recommend Date :</span
                            >
                        </v-col>
                        <v-col md="2">
                            <span class="font-weight-bold">{{
                                recommend_date
                            }}</span>
                        </v-col>
                        <v-col md="2">
                            <span class="font-weight-bold">Recommend By :</span>
                        </v-col>
                        <v-col md="2">
                            <span class="font-weight-bold">{{
                                recommend_by
                            }}</span>
                        </v-col>
                        <v-col md="2">
                            <span class="font-weight-bold">Singlepart :</span>
                        </v-col>
                        <v-col md="2">
                            <span class="font-weight-bold">{{
                                singlepart
                            }}</span>
                        </v-col>
                        <v-col md="2">
                            <span class="font-weight-bold">Issue Date :</span>
                        </v-col>
                        <v-col md="2">
                            <span class="font-weight-bold">{{
                                issue_date
                            }}</span>
                        </v-col>
                        <v-col md="2">
                            <span class="font-weight-bold">Issue Date :</span>
                        </v-col>
                        <v-col md="2">
                            <span class="font-weight-bold">{{
                                issue_date
                            }}</span>
                        </v-col>
                        <v-col md="2">
                            <span class="font-weight-bold">Issue Date :</span>
                        </v-col>
                        <v-col md="2">
                            <span class="font-weight-bold">{{
                                issue_date
                            }}</span>
                        </v-col>
                        <v-col md="2">
                            <span class="font-weight-bold">Issue Date :</span>
                        </v-col>
                        <v-col md="2">
                            <span class="font-weight-bold">{{
                                issue_date
                            }}</span>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="dialog = false"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- </v-card-text> -->
        <!-- </v-alert> -->
    </div>
</template>
<script>
import axios from "axios"
import _ from "lodash"

export default {
    props: ["detailcase"],
    beforeMount() {},
    mounted() {
        // console.log(this.detailcase, "-main data")
    },
    methods: {
        async showpart(value) {
            const url =
                `${process.env.VUE_APP_ROOT_API}/api/part-detail/` + value

            try {
                let { data } = await axios.get(url)
                this.datapart = data
            } catch (error) {
                console.log(error.message)
            }
        },
        doCopy(text) {
            navigator.clipboard.writeText(text)
        },
    },
    data() {
        return {
            datapart: [],
            dialogpart: false,
            dialog: false,
            classHead: "text-uppercase darken-3 black--text body-2",
            headers: [
                {
                    text: "Part Status",
                    value: "status",
                    class: this.classHead,
                },
                {
                    text: "Sub",
                    value: "subcase",
                    class: this.classHead,
                },
                {
                    text: "PO Number",
                    value: "ponumber",
                    class: this.classHead,
                },
                {
                    text: "Part No",
                    value: "part_name",
                    class: this.classHead,
                },
                {
                    text: "Part Description",
                    value: "part_description",
                    class: this.classHead,
                },
                {
                    text: "RMA",
                    value: "rma",
                    class: this.classHead,
                },
                {
                    text: "ETA",
                    value: "eta",
                    class: this.classHead,
                },
                {
                    text: "CE Status",
                    value: "ce_status",
                    class: this.classHead,
                },
                {
                    text: "CT Old",
                    value: "ct_old",
                    class: this.classHead,
                },
                {
                    text: "CT New",
                    value: "ct_new",
                    class: this.classHead,
                },
                {
                    text: "Uefi",
                    value: "uefi",
                    class: this.classHead,
                },
                {
                    text: "Actions",
                    value: "action",
                    class: this.classHead,
                },
            ],
        }
    },
}
</script>
